import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const getIconBg = (color: string) => {
    if (color === 'accent') return 'bg-accent-100 text-accent-700';
    if (color === 'secondary') return 'bg-secondary-100 text-secondary-700';
    return 'bg-primary-100 text-primary-700';
  };

  const getHoverBorder = (color: string) => {
    if (color === 'accent') return 'hover:border-accent-300';
    if (color === 'secondary') return 'hover:border-secondary-300';
    return 'hover:border-primary-300';
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            探索约炮攻略
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            从技巧到平台，从话术到安全，全方位覆盖你的约炮需求
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 ${getHoverBorder(cat.color)} transition-all cursor-pointer`}
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${getIconBg(cat.color)}`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-500">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}